/** #11 — "Perfect for…" chips per product. Helps shoppers self-identify. */
const VIBE_MAP = [
  { tag: 'Date night',      match: ['oud','sweet','vanilla','gourmand','rose','romantic'] },
  { tag: 'Office / daytime',match: ['fresh','citrus','musk','clean','aquatic'] },
  { tag: 'Weekend chill',   match: ['woody','cedar','musk','soft'] },
  { tag: 'Big events',      match: ['oud','spicy','pepper','saffron','floral','intense'] },
  { tag: 'Rainy day',       match: ['woody','vanilla','tonka','cozy','warm'] },
  { tag: 'Summer fresh',    match: ['citrus','aquatic','marine','fresh','bergamot','grapefruit'] },
  { tag: 'Confidence boost',match: ['oud','signature','bold','intense'] },
  { tag: 'Cozy nights',     match: ['gourmand','vanilla','tonka','caramel','cocoa'] },
  { tag: 'Romantic',        match: ['floral','rose','jasmine','peony'] },
];

function deriveVibes(product) {
  if (Array.isArray(product?.vibes) && product.vibes.length) return product.vibes.slice(0, 3);
  const blob = [
    product?.scent_family, product?.family,
    ...(Array.isArray(product?.notes) ? product.notes : []),
    ...(product?.notes?.top || []),
    ...(product?.notes?.middle || product?.notes?.heart || []),
    ...(product?.notes?.base || []),
    ...(product?.top_notes || []),
    ...(product?.middle_notes || []),
    ...(product?.heart_notes || []),
    ...(product?.base_notes || []),
    product?.description, product?.vibe, product?.tagline, product?.gender,
  ].filter(Boolean).join(' ').toLowerCase();
  const found = [];
  for (const v of VIBE_MAP) {
    if (v.match.some(m => blob.includes(m))) found.push(v.tag);
    if (found.length >= 3) break;
  }
  return found;
}

export default function PerfectFor({ product }) {
  const vibes = deriveVibes(product);
  if (!vibes.length) return null;
  return (
    <div className="flex items-center gap-2 flex-wrap" data-testid="perfect-for">
      <span className="text-[10px] uppercase tracking-[0.25em] text-white/40 font-sans mr-1">Perfect for</span>
      {vibes.map((v, i) => (
        <span
          key={i}
          data-testid={`vibe-chip-${i}`}
          className="text-[11px] font-sans px-2.5 py-1 bg-[#D4AF37]/8 border border-[#D4AF37]/25 text-[#D4AF37] rounded-full"
        >
          {v}
        </span>
      ))}
    </div>
  );
}
